import * as React from "react";
import NotFound from "../components/404/404";
import BasicLayout from "../layouts/basic-layout";

class NotFoundPage extends React.Component<{}, {}> {
  public componentDidMount() {
    analytics.page("404");
  }
  public render() {
    return (
      <div>
        <BasicLayout
          heroTitle="Oops! Seems you got lost"
          heroSubtitle="The page you are looking for can’t be found."
          showIntegrations={false}
          showFooter={false}
          showCta={false}
          variableComponent={NotFound}
        />
      </div>
    );
  }
}

export default NotFoundPage;



// WEBPACK FOOTER //
// ./src/pages/404.tsx